import { DecimalPipe, PercentPipe } from '@angular/common';
import {
    Component,
    ElementRef,
    EventEmitter,
    HostBinding,
    Inject,
    Input,
    OnInit,
    Optional,
    Output,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { NgbActiveModal, NgbModal } from '@cmps/ng-bootstrap';
import { Observable } from 'rxjs';

import { actions, addPageAction } from '../../../coaching/new-relic';
import { WidgetConfiguration } from '../../../widget/config.widget.model';
import { CMPS_WIDGET_CONFIG } from '../../../widget/widget.metadata';
import { TranslationKeyMap } from '../../coaching-insight.i18n';
import { OldOaWidgetTypeId } from '../../coaching-insight.module';
import { ColumnConfigItem } from '../models/coaching.global.model';
import {
    ACTIVE_TAB_VIEW,
    CommitmentListEntry,
    OaPerson,
    Opportunity,
} from '../models/oa.model';
import { CoachingInsightWidgetService } from '../services/coaching-insight.widget.service';
import { TeamOAService } from '../services/team-oa.service';

// maintain a list of Team Member Metrics
@Component({
    selector: '[personRow]',
    templateUrl: './person-row.component.html',
    // changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [PercentPipe, DecimalPipe],
    host: {
        class: 'team-oa-row',
    },
})
export class PersonRowComponent implements OnInit {
    @Input() columns: Observable<ColumnConfigItem[]>;
    @Input() member: OaPerson;
    @Input() rowExpanded: boolean;
    @Input() rowIndex: number;
    @Input() activeMetric: Opportunity;
    @Input() activeMember: OaPerson;
    @Input() activecolumns: number;
    @Input() activeView: ACTIVE_TAB_VIEW;

    @Output() rowExpandedChange: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    @Output() metricselectedChange: EventEmitter<string> =
        new EventEmitter<string>();

    @Output() openedWithNonKPIButton: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    @Output() openedWithoutOpp: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    @ViewChild('oatooltip') oatooltip: TemplateRef<any>;
    @ViewChild('nonkpitooltip', { static: true })
    nonkpitooltip: TemplateRef<any>;

    @ViewChild('detailRow') detailRowTemplate: TemplateRef<any>;

    hasPendingData: boolean = false;

    moreOAMetricsOpened: boolean = false;

    ACTIVE_TAB_VIEW = ACTIVE_TAB_VIEW;

    destroyedComponent = false;

    @HostBinding('class.row-expanded')
    public get isRowExpanded(): boolean {
        return this.member.active === true;
    }

    @HostBinding('class.member-sec-top-line')
    public get topline(): boolean {
        return this.rowIndex === 0;
    }

    i18n = TranslationKeyMap;

    constructor(
        private readonly _coachingInsightService: CoachingInsightWidgetService,
        private readonly _teamOAService: TeamOAService,
        private readonly _modalService: NgbModal,
        public activeModal: NgbActiveModal,
        private readonly _el: ElementRef,
        private readonly numberPipe: DecimalPipe,
        // private readonly cdRef: ChangeDetectorRef,
        @Optional()
        @Inject(CMPS_WIDGET_CONFIG)
        private readonly _config: WidgetConfiguration,
    ) {}

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnInit() {
        if (this.destroyedComponent) {
            // this.cdRef.reattach();
        }
        this.destroyedComponent = false;
    }

    forceOADetails($event, performerOnly = false): void {
        addPageAction(actions.OpportunityAlignment.OPPORTUNITY_USER_CLICK, {
            userId: this.member?.userId,
            oldOaWidget: this._config?.typeId === OldOaWidgetTypeId,
        });

        if (this._config && this._config.typeId !== OldOaWidgetTypeId) {
            this.openedWithoutOpp.emit(performerOnly);
            this._teamOAService.setActiveMember(this.member);
            return;
        }

        this._teamOAService.toggleTeamOARow(this.member);
        this.rowExpandedChange.emit(this.member.active === true);
        // triggered by clicking name or nonkpi, so no metric is clicked
        this._teamOAService.setActiveMetric(null);
        if (this.member.active === false) {
            this.openedWithNonKPIButton.emit(false);
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    setActiveMember(opp?: Opportunity) {
        if (this._config && this._config.typeId !== OldOaWidgetTypeId) {
            this._teamOAService.setActiveMember(this.member);
            this._teamOAService.setActiveMetric(opp);
            return;
        }

        if (!this.member) {
            return;
        }

        if (
            this.activeMember &&
            this.member.userId !== this.activeMember.userId
        ) {
            this._teamOAService.toggleTeamOARow(this.member);
            this.rowExpandedChange.emit(this.member.active === true);
            return;
        }

        if (!this.activeMetric) {
            if (this.member.active && this.activeMetric) {
                return;
            }

            this._teamOAService.toggleTeamOARow(this.member);
            this.rowExpandedChange.emit(this.member.active === true);
        } else if (this.activeMetric.metricId) {
            if (this.activeMetric) {
                this.forceOADetails(null);
            }

            if (this.member.active) {
                // eslint-disable-next-line no-useless-return
                return;
            }
        } else {
            // open/close normally
            this.forceOADetails(null);
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    identifyNonKPIObject(index: number, item: CommitmentListEntry) {
        if (item) {
            return item.behaviour != null ? item.behaviour : item.subbehaviour;
        }
        return false;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnDestroy() {
        this.destroyedComponent = true;
        // this.cdRef.detach();
    }
}
